<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label"
    >{{ httpService.getTransation().Profile }}</span
  >
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="profile-modal-content">
  <div class="profile-section">
    <div class="profile-section-header">
      <mat-icon class="profile-section-icon">straighten</mat-icon>
      <label id="unit-of-measure-label" class="profile-section-label">
        {{ httpService.getTransation().UnitOfMeasure }}
      </label>
    </div>
    <mat-radio-group
      aria-labelledby="unit-of-measure-label"
      class="profile-radio-group"
      [(ngModel)]="unitOfMeasure"
    >
      <mat-radio-button class="profile-radio-button" [value]="unitOfMeasures.Inch">
        {{ httpService.getTransation().Inch }}
      </mat-radio-button>
      <mat-radio-button class="profile-radio-button" [value]="unitOfMeasures.Cm">
        {{ httpService.getTransation().Cm }}
      </mat-radio-button>
      <mat-radio-button class="profile-radio-button" [value]="unitOfMeasures.Mm">
        {{ httpService.getTransation().Mm }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="profile-section-divider"></div>

  <div class="profile-section">
    <div class="profile-section-header">
      <mat-icon class="profile-section-icon">language</mat-icon>
      <label id="language-label" class="profile-section-label">
        {{ httpService.getTransation().Language }}
      </label>
    </div>
    <mat-form-field appearance="outline" class="profile-form-field">
      <mat-select [(ngModel)]="language" aria-labelledby="language-label">
        <mat-select-trigger>
          <span class="language-option" *ngIf="getSelectedLanguageOption()">
            <span class="language-flag">{{ getSelectedLanguageOption()?.flag }}</span>
            <span class="language-label">{{ getSelectedLanguageOption()?.label }}</span>
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let lang of languageOptions" [value]="lang.value">
          <span class="language-option">
            <span class="language-flag">{{ lang.flag }}</span>
            <span class="language-label">{{ lang.label }}</span>
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end" class="profile-modal-actions">
  <button mat-raised-button color="primary" class="profile-button-primary" (click)="onSave()">
    {{ httpService.getTransation().Save }}
  </button>
  <button mat-stroked-button class="profile-button-secondary" cdkFocusInitial (click)="onClose()">
    {{ httpService.getTransation().Close }}
  </button>
</div>
